import Api from "@/services/Api";

/**
 * TAIR3-873: record a "turn away" when the detail-page router blocks an
 * unauthenticated / unsubscribed visitor client-side (before any backend call
 * would otherwise log the hit).
 *
 * Fire-and-forget: must never block navigation or surface an error to the
 * user. Failures are swallowed — this is analytics only.
 *
 * @param {string} uri - the full URL the visitor was trying to reach
 */
export function logTurnaway(uri) {
  try {
    Api()
      .post("logging/turnaway", { uri })
      .catch(() => {});
  } catch (e) {
    /* analytics only — ignore */
  }
}
